export default {
  common__validation__is_required: '请输入',
  common__validation__invalid_format: '请输入正确的值',
  common__validation__invalid_file_size: '文件大小超过上限（{size}）',
};
